/// <amd-module name="SuiteCommerce.PagePrinter.ItemDetailsLayout.QRHelper"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.PagePrinter.ItemDetailsLayout.QRHelper", ["require", "exports", "SuiteCommerce.PagePrinter.ItemDetailsLayout.Helper"], function (require, exports, ItemDetailsLayout_Helper_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var QRHelper = /** @class */ (function (_super) {
        __extends(QRHelper, _super);
        function QRHelper() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        QRHelper.prototype.prepareHelpers = function () {
            this.helpers = [
                {
                    name: 'getFieldValue',
                    helperAction: function (item, field) {
                        var fieldValue = item.get(field.fieldId);
                        return fieldValue;
                    },
                },
                {
                    name: 'isQRCode',
                    helperAction: function (fieldType) {
                        return fieldType === 'QR Code';
                    },
                },
            ];
        };
        return QRHelper;
    }(ItemDetailsLayout_Helper_1.Helper));
    exports.QRHelper = QRHelper;
});
